<template>
  <div class="list">
    <v-data-table class="list-table"
                  :headers="headers"
                  :items="list"
                  :loading="loading"
                  :hide-actions="true"
                  no-data-text="Nenhum resultado encontrado"
                  no-results-text="Nenhum resultado encontrado"
                  disable-initial-sort>

      <template slot="items"
                slot-scope="props">
        <slot :item="props.item"></slot>
      </template>
    </v-data-table>

    <infinite-loading :identifier="loadingId"
                      @infinite="emitLoad">
      <div slot="no-results"></div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      internalInfiniteId: +new Date(),
    };
  },

  props: {
    infiniteId: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: true
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    loadingId() {
      return this.infiniteId || this.internalInfiniteId;
    },
  },

  created() {},

  beforeDestroy() {},

  methods: {
    reloadList() {
      this.$emit("reload");
    },
    emitLoad($state) {
      this.$emit("load", $state);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  .list-table {
    ::v-deep .v-table__overflow {
      padding-bottom: 50px;
    }
  }
}
</style>
